<template>
    <div>
        <v-view :tableData="tableData"
                :tableProps="tableProps"
                :modalProps="modalProps"
                :columns="columns"
                :routes="routes"
                :initialSort="initialSort"
                :rowButtonAction="rowButtonAction"
                v-model:selectedRows="selectedRows">

            <template #crud="formProps">
                <AlertForm :formProps="formProps">
                </AlertForm>
            </template>
            <template #search="searchProps">
                <AlertSearch :searchProps="searchProps">
                </AlertSearch>
            </template>

        </v-view>
    </div>
</template>

<script setup>
import AlertForm from './AlertForm.vue'
import AlertSearch from './AlertSearch.vue'
import { rowButtonAction } from '@pages/Helper/crud_utils.js'
import { ref } from "vue";

const props = defineProps({
    tableData: Object,
    tableProps: Object,
    modalProps: Object,
    columns: Object,
    routes: Object,
    initialSort: Object,
})

const selectedRows = ref([])

//------------------------------------------------------------------------------

</script>

<style lang="scss" scoped></style>
